define([], function() {
  'use strict';
  return {
    assets: {
      audio: '/v1.0/Shelf/{shelf_id}/audio/rollover.mp3'
    }
  };
});
